export default __webpack_public_path__ + "static/media/on.bb93b592.svg";